var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar-home'),_c('app-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}]}),_c(_vm.currentComponent,{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],tag:"component",attrs:{"layout":_vm.layout}}),_c('footer-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }